import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class SearchBarHelperComponent {

    constructor() {
    }

    onSearchBarLoaded(event) {

    }

    getSearchBar(args): any {
        return;
    }

}
